import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";

export default function ArticlesSection() {
  const featured = articles.slice(0, 3);
  const rest = articles.slice(3, 9);

  return (
    <section id="articles" className="py-20 md:py-24 bg-stone-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12">
          <div>
            <div className="flex items-center gap-3 mb-3">
              <span className="h-px w-8 bg-amber-500"></span>
              <span className="text-amber-500 text-xs font-bold uppercase tracking-[0.2em]">HipoBuy Blog</span>
            </div>
            <h2 className="text-3xl md:text-5xl font-black text-gray-900 leading-tight">
              Latest Guides<br />
              <span className="text-amber-500">&amp; News</span>
            </h2>
          </div>
          <div className="flex flex-col items-start md:items-end gap-3">
            <p className="text-gray-500 text-sm leading-relaxed max-w-xs md:text-right">
              Expert advice on HipoBuy 2026 shopping, sizing guides, quality tips, and the latest fashion trends.
            </p>
            <Link
              to={`/${articles[0].slug}`}
              className="inline-flex items-center gap-2 px-5 py-2.5 bg-gray-900 hover:bg-amber-500 text-white font-bold rounded-full transition-all duration-300 cursor-pointer whitespace-nowrap text-sm"
            >
              View All Articles
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line"></i>
              </div>
            </Link>
          </div>
        </div>

        {/* Featured 3 */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-5">
          {featured.map((article, idx) => (
            <Link
              key={article.id}
              to={`/${article.slug}`}
              className={`group block overflow-hidden rounded-2xl cursor-pointer relative ${idx === 0 ? "md:row-span-1" : ""}`}
            >
              <div className="h-52 overflow-hidden bg-stone-200">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                />
              </div>
              <div className="bg-white p-5 border border-stone-100 border-t-0 rounded-b-2xl">
                <div className="flex items-center gap-2 mb-3">
                  <span className="px-2.5 py-0.5 bg-amber-500 text-white text-xs font-bold rounded-full">
                    {article.category}
                  </span>
                  <span className="text-gray-400 text-xs">{article.readTime}</span>
                </div>
                <h3 className="text-sm font-bold text-gray-900 leading-snug mb-2 group-hover:text-amber-600 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-gray-500 text-xs leading-relaxed line-clamp-2 mb-3">{article.excerpt}</p>
                <div className="flex items-center gap-1 text-amber-500 text-xs font-bold">
                  Read More
                  <div className="w-3 h-3 flex items-center justify-center translate-x-0 group-hover:translate-x-1 transition-transform">
                    <i className="ri-arrow-right-line"></i>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>

        {/* Rest 6 */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-8">
          {rest.map((article) => (
            <Link
              key={article.id}
              to={`/${article.slug}`}
              className="group flex gap-4 p-4 bg-white rounded-xl hover:bg-amber-50 transition-all cursor-pointer border border-stone-100 hover:border-amber-200"
            >
              <div className="w-20 h-20 shrink-0 rounded-xl overflow-hidden bg-stone-100">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="flex-1 min-w-0">
                <span className="inline-block px-2 py-0.5 bg-amber-50 text-amber-600 text-xs font-bold rounded-full mb-1">{article.category}</span>
                <h4 className="text-xs font-bold text-gray-900 leading-snug line-clamp-2 group-hover:text-amber-600 transition-colors">
                  {article.title}
                </h4>
                <span className="text-gray-400 text-xs mt-1.5 block">{article.date}</span>
              </div>
            </Link>
          ))}
        </div>

        {/* All articles */}
        <div className="bg-white rounded-2xl border border-stone-100 p-6 md:p-8">
          <div className="flex items-center justify-between mb-5">
            <h3 className="text-base font-black text-gray-900">All HipoBuy 2026 Articles</h3>
            <span className="text-xs text-gray-400">{articles.length} articles</span>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-2">
            {articles.slice(9).map((article) => (
              <Link
                key={article.id}
                to={`/${article.slug}`}
                className="group flex items-start gap-2.5 p-3 rounded-xl hover:bg-amber-50 transition-all cursor-pointer"
              >
                <div className="w-5 h-5 flex items-center justify-center text-amber-500 shrink-0 mt-0.5">
                  <i className="ri-article-line text-sm"></i>
                </div>
                <span className="text-xs font-medium text-gray-700 group-hover:text-amber-600 transition-colors line-clamp-2 leading-snug">
                  {article.title}
                </span>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
